import React from "react";
import { ConfirmModal } from "../../../../boxes/ConfirmModal/ConfirmModal";

const BlacklistNumbersModal = ({
  onClose,
  onConfirm,
  phoneNumbers,
  isConfirming,
}) => {
  return (
    <ConfirmModal
      isOpen
      onClose={onClose}
      title="Confirmation Required"
      onConfirm={onConfirm}
      onCancel={onClose}
      confirmTitle={"Yes"}
      cancelTitle={"No"}
      isConfirming={isConfirming}
    >
      {`Are you sure you want to block  ${
        phoneNumbers.length === 1 ? " this user number" : "these user numbers"
      } ?`}
    </ConfirmModal>
  );
};

export default BlacklistNumbersModal;
